import React, { useEffect, Suspense, lazy } from 'react';
import { FeetAnklesHeroSection } from '../components/FeetAnklesHeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { useAnalytics } from '../hooks/useAnalytics';
// Lazy load below-the-fold components for faster initial load
const MechanismSection = lazy(() => import('../components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const UseCasesSection = lazy(() => import('../components/UseCasesSection').then(m => ({
  default: m.UseCasesSection
})));
const HowToUseSection = lazy(() => import('../components/HowToUseSection').then(m => ({
  default: m.HowToUseSection
})));
const TrustSection = lazy(() => import('../components/TrustSection').then(m => ({
  default: m.TrustSection
})));
const BundleSection = lazy(() => import('../components/BundleSection').then(m => ({
  default: m.BundleSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const CTASection = lazy(() => import('../components/CTASection').then(m => ({
  default: m.CTASection
})));
// Loading fallback for lazy components
function SectionLoader() {
  return <div className="w-full py-12 flex items-center justify-center" data-id="element-1744">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ginger" data-id="element-1745"></div>
    </div>;
}
export function FeetAnklesLandingPage() {
  const {
    trackPageView
  } = useAnalytics();
  useEffect(() => {
    trackPageView();
  }, [trackPageView]);
  return <div className="min-h-screen bg-white" data-id="element-1746">
      <FeetAnklesHeroSection data-id="element-1747" />
      <ProblemSection data-id="element-1748" />
      <SolutionSection data-id="element-1749" />

      <Suspense fallback={<SectionLoader data-id="element-1751" />} data-id="element-1750">
        <div id="how-it-works" className="scroll-mt-20" data-id="element-1752">
          <MechanismSection data-id="element-1753" />
        </div>

        <div id="benefits" className="scroll-mt-20" data-id="element-1754">
          <BenefitsSection beforeImage="https://cdn.magicpatterns.com/uploads/hZndYsjN2V4f1oHP9oe6UN/u8896349413_Photorealistic_close-up_image_of_a_55-year-old_wo_189155f5-fabb-493c-ab8f-a49c63d2b15f_2.png" afterImage="https://cdn.magicpatterns.com/uploads/wWr5y6KWucVMQPKFDnR873/u8896349413_Photorealistic_close-up_image_of_the_same_55-year_b01f4299-9b01-4632-b9f5-10e6799fcbbd_0.png" data-id="element-1755" />
        </div>

        <UseCasesSection data-id="element-1756" />

        <div id="how-to-use" className="scroll-mt-20" data-id="element-1757">
          <HowToUseSection data-id="element-1758" />
        </div>

        <TrustSection data-id="element-1759" />

        <div id="bundles" className="scroll-mt-20" data-id="element-1760">
          <BundleSection data-id="element-1761" />
        </div>

        <div id="faq" className="scroll-mt-20" data-id="element-1762">
          <FAQSection data-id="element-1763" />
        </div>

        <CTASection data-id="element-1764" />
      </Suspense>
    </div>;
}